// size chart
jQuery(function ($) {
		var $sizeChart = $('#size-chart');
		$("select.sc-size_type").on('change', function () {
			var selected = $(this).val().toLowerCase();
			$sizeChart.removeClass('active-uk active-au active-us active-eu').addClass('active-' + selected);
			$("select.sc-size_type").not($(this)).val($(this).val());
		});
		$("select#sc-gender").on('change', function () {
			var selected = $(this).val().toLowerCase();
			$sizeChart.removeClass('active-women active-men').addClass('active-' + selected);
		});
		$("select#sc-size_unit").on('change', function () {
			var selected = $(this).val().toLowerCase();
			$sizeChart.removeClass('active-in active-cm').addClass('active-' + selected);
		});
});

jQuery(document).ready(function() {   
   jQuery(".video-section__media button").click();
});

     jQuery(document).ready(function() {   
       if(jQuery(window).width() < 749){
jQuery(".footer-block--menu h2").click(function() {     
	jQuery(this).closest(".footer-block--menu").find("ul").slideToggle();
});
         jQuery(".footer-block__brand-info h2").click(function() {     
	jQuery(".footer-block__brand-info div.rte").slideToggle();
});
       }
});


jQuery(document).ready(function() {   
    jQuery(".bsc").click(function() {  
      jQuery(".sc-tabs p").removeClass("tab-active");
      jQuery(this).addClass("tab-active");
      jQuery(".sc-content").removeClass("sc-tab-active");
      jQuery(".bsc-bx").addClass("sc-tab-active");
    });
    jQuery(".nsc").click(function() {  
      jQuery(".sc-tabs p").removeClass("tab-active");
      jQuery(this).addClass("tab-active");
      jQuery(".sc-content").removeClass("sc-tab-active");
      jQuery(".nsc-bx").addClass("sc-tab-active");
    });
    jQuery(".brsc").click(function() {  
      jQuery(".sc-tabs p").removeClass("tab-active");
      jQuery(this).addClass("tab-active");
      jQuery(".sc-content").removeClass("sc-tab-active");
      jQuery(".brsc-bx").addClass("sc-tab-active");
    });
    jQuery(".rsc").click(function() {  
      jQuery(".sc-tabs p").removeClass("tab-active");
      jQuery(this).addClass("tab-active");
      jQuery(".sc-content").removeClass("sc-tab-active");
      jQuery(".rsc-bx").addClass("sc-tab-active");
    });
});         

// autoplay product gallery video
function isElementInViewport (el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}

jQuery(document).ready(function($) {
    var played = false;
  $(window).on('DOMContentLoaded load resize scroll', function () {
      if(played) return;
      var poster = jQuery('.product-page .product__media-list .media-type-video button.deferred-media__poster');
      if(poster){
        poster = poster[0];
        var rect = poster.getBoundingClientRect();
          var visible = rect.top >= 0 && rect.left >= 0;
          if (visible) {
              if (jQuery(window).width() >= 750) {
                  jQuery('.product-page .product__media-list .media-type-video button.deferred-media__poster').trigger('click');
                  setTimeout(function(){
                    jQuery('.product-page .product__media-list video').removeAttr( "controls" );
                  }, 500);
                 played = true;
            }
          }
      }
    });
});